'use client'

import React from 'react'
import { Scales } from 'phosphor-react'
import { Card } from '@/components/ui/card'

export type KeyDecision = {
  question: string
  tension: string
  choice: string
}

type KeyDecisionsProps = {
  decisions: KeyDecision[]
  className?: string
}

export default function KeyDecisions({ decisions, className = '' }: KeyDecisionsProps) {
  return (
    <section className={`mb-16 md:mb-20 ${className}`.trim()} aria-labelledby="key-decisions-heading">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 brutal-chip bg-[var(--brutal-kraft)]">
          <Scales weight="duotone" className="w-5 h-5 text-[var(--brutal-ink)]" aria-hidden="true" />
        </div>
        <h3 id="key-decisions-heading" className="text-xl md:text-2xl font-bold text-[var(--brutal-ink)]">
          Key Decisions
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {decisions.map((decision) => (
          <Card key={decision.question} className="brutal-panel p-6">
            <p className="text-xs font-brutal-mono uppercase tracking-wide text-[var(--brutal-muted)] mb-3">
              Tradeoff
            </p>
            <h4 className="text-base md:text-lg font-semibold text-[var(--brutal-ink)] mb-3">
              {decision.question}
            </h4>
            <p className="text-sm text-[var(--brutal-muted)] leading-relaxed mb-4">
              {decision.tension}
            </p>
            <p className="text-sm text-[var(--brutal-ink)] leading-relaxed">
              <span className="font-semibold">What we chose:</span> {decision.choice}
            </p>
          </Card>
        ))}
      </div>
    </section>
  )
}
